<template>
    <div class="contentWrapper">
        <div class="contentBlock">
            <h3>Поддержать</h3>
            <p>В рамках проекта TUZZ ARENA мы начали <a v-bind:href="$store.state.arenaURL" target="_blank">проводить турниры</a> среди участников Альянса. Спонсоров нет, поэтому призовой фонд пока формируется исключительно из ваших пожертвований.</p>
            <p><b>Все собранные деньги направляются только на выдачу наград и никуда больше</b>. Дабы обеспечить <b>прозрачность</b> расходования средств, <b>обязуемся предоставить отчетность</b> по запросу всем, кто пожертвует более 50 рублей (указать ник в игре при оплате).</p>
            <iframe src="https://money.yandex.ru/quickpay/shop-widget?writer=seller&targets=%D0%9D%D0%B0%20%D0%BF%D1%80%D0%BE%D0%B2%D0%B5%D0%B4%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%82%D1%83%D1%80%D0%BD%D0%B8%D1%80%D0%BE%D0%B2&targets-hint=&default-sum=50&button-text=12&payment-type-choice=on&comment=on&hint=%D0%9D%D0%B8%D0%BA%20%D0%B2%20%D0%B8%D0%B3%D1%80%D0%B5%2C%20%D0%BF%D0%BE%D0%B6%D0%B5%D0%BB%D0%B0%D0%BD%D0%B8%D1%8F&successURL=https%3A%2F%2Fcrossclan.ru&quickpay=shop&account=4100110152386310" width="100%" height="313" frameborder="0" allowtransparency="true" scrolling="no"></iframe>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Assist',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    NewTabUrlOpen(val){
        window.open(val, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnDiscordLayout {
   margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Assist.vue